<section class="mission-details-modal" role="document">
  <button
    type="button"
    class="mission-details-modal__close"
    [attr.aria-label]="'promotions.missions.detail.close' | translate"
    (click)="close()"
  >
    <img src="assets/img/promotions/detail/modal-close-linear.svg" alt="" aria-hidden="true" />
  </button>

  <header class="mission-details-modal__header">
    <span>{{ 'promotions.missions.detail.eyebrow' | translate }}</span>
    <h2>{{ modalData.title }}</h2>
    <p>{{ modalData.description }}</p>
  </header>

  <div class="mission-details-modal__summary">
    <dl>
      <dt>{{ 'promotions.missions.detail.status' | translate }}</dt>
      <dd>{{ modalData.statusLabel | translate }}</dd>
    </dl>
    @if (modalData.objectiveProgress; as objectiveProgress) {
      <dl data-testid="mission-details-objective">
        <dt>{{ 'promotions.missions.detail.progress' | translate }}</dt>
        <dd>
          {{
            'promotions.missions.objectiveProgress'
              | translate: { current: objectiveProgress.current, target: objectiveProgress.target }
          }}
        </dd>
      </dl>
    }
    <dl>
      <dt>{{ 'promotions.missions.detail.entries' | translate }}</dt>
      <dd>
        @if (modalData.maxEntriesPerUser !== null) {
          {{
            'promotions.missions.entriesProgress'
              | translate: { count: modalData.entriesCount, max: modalData.maxEntriesPerUser }
          }}
        } @else {
          {{
            (modalData.entriesCount === 1
              ? 'promotions.missions.entriesCount'
              : 'promotions.missions.entriesCount_other'
            ) | translate: { count: modalData.entriesCount }
          }}
        }
      </dd>
    </dl>
    <dl>
      <dt>{{ 'promotions.missions.detail.remainingEntries' | translate }}</dt>
      <dd>
        @if (modalData.remainingEntries !== null) {
          {{ modalData.remainingEntries }}
        } @else {
          {{ 'promotions.missions.unlimited' | translate }}
        }
      </dd>
    </dl>
    <dl>
      <dt>{{ 'promotions.missions.detail.timeRemaining' | translate }}</dt>
      <dd data-testid="mission-time-remaining">{{ timeRemaining().key | translate: timeRemaining().params }}</dd>
    </dl>
  </div>

  @if (modalData.progress !== null) {
    <div class="mission-details-modal__progress" aria-hidden="true">
      <span>
        <i [style.width.%]="modalData.progress"></i>
      </span>
    </div>
  }
</section>
